// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationAddress } from './priorAuthorizationAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationFacility {
    'name': string;
    'npi': string;
    'fax': string;
    'phone'?: string;
    'phoneExtension'?: string;
    'address': PriorAuthorizationAddress | null;
    'contactName'?: string;
    'email'?: string;
    'taxId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationFacility>> = [
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "phoneExtension",
            "baseName": "phoneExtension",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "PriorAuthorizationAddress"
        },
        {
            "name":     "contactName",
            "baseName": "contactName",
            "type":     "string"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
        {
            "name":     "taxId",
            "baseName": "taxId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationFacility.attributeTypeMap;
    }
}
